<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22.18 22.23"
    class="svg-icon"
  >
    <path
      d="M967.42,536.88c-1.47,1.68-2.93,3.36-4.4,5a.94.94,0,0,0-.17,1.25,2.65,2.65,0,0,1-.31,3c-.36.45-.75.55-1.2.09q-4.26-4.28-8.54-8.53c-.51-.51-.36-.92.12-1.29a2.5,2.5,0,0,1,2.9-.29,1,1,0,0,0,1.34-.2c1.5-1.31,3-2.57,4.51-3.92.62-.57,1-.51,1.52.09a35.4,35.4,0,0,0,4,4C967.45,536.34,967.67,536.53,967.42,536.88Z"
      transform="translate(-948.61 -528.26)"
    />
    <path
      d="M956.72,544.06a31.93,31.93,0,0,1-8.11,6.43,22.87,22.87,0,0,1,3.33-4.66c1-1.12,2.14-2.14,3.18-3.25.43-.46.8-.55,1.09,0S957.58,543.17,956.72,544.06Z"
      transform="translate(-948.61 -528.26)"
    />
    <path
      d="M970.69,535.46a1.91,1.91,0,0,1-2.91.13l-4.32-4.33a1.78,1.78,0,0,1-.64-1.59,1.58,1.58,0,0,1,.83-1.35c.57-.25.85.3,1.18.62q2.64,2.61,5.25,5.25C970.42,534.54,971,534.85,970.69,535.46Z"
      transform="translate(-948.61 -528.26)"
    />
  </svg>
</template>

<script>
export default {
  name: "IconPin"
};
</script>
